import { useQuery } from '@tanstack/react-query';
import type { RecordLogEntry } from '@kontor/shared';
import { api } from '../api';
import { CollapsibleCard } from './CollapsibleCard';

const stamp = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Berlin' });

export type LogLabels = Record<string, (d: Record<string, unknown>) => string>;

/**
 * Verlauf eines Belegs als aufklappbare Karte: je Eintrag Zeitpunkt, was geschah und wer es war („Ausgestellt als RE-2026-0015 von Dimitri Kovalenko“). Die Einträge kommen aus dem
 * Änderungsprotokoll (`path` liefert RecordLogEntry[]), die Sätze aus `labels`. Unbekannte Aktionen erscheinen mit ihrem Schlüssel, damit nichts verloren geht.
 */
export function RecordHistory({ path, queryKey, labels, storageKey, fallback }: { path: string; queryKey: unknown[]; labels: LogLabels; storageKey: string; fallback?: (action: string, data: Record<string, unknown>) => string }) {
  const log = useQuery({ queryKey, queryFn: async () => (await api<{ data: RecordLogEntry[] }>('GET', path)).data });
  return (
    <CollapsibleCard title="Verlauf" storageKey={storageKey} defaultOpen>
      {log.isLoading && <p className="muted">Wird geladen …</p>}
      {log.isError && <p className="muted">Der Verlauf konnte nicht geladen werden.</p>}
      {log.data && log.data.length === 0 && <p className="muted">Noch keine Einträge.</p>}
      {log.data && log.data.length > 0 && (
        <ul className="history-list">
          {log.data.map((e) => (
            <li key={e.id}>
              <span className="history-list__when">{stamp.format(new Date(e.at))} Uhr</span>
              <span>
                {labels[e.action] ? labels[e.action]!(e.data) : fallback ? fallback(e.action, e.data) : e.action}
                <span className="muted">{e.actorName ? ` von ${e.actorName}` : ' vom System'}</span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </CollapsibleCard>
  );
}
